import { isPlatformServer } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { getFullPath } from 'src/app/lib/get-full-path';
import { GalleryService } from 'src/app/services/gallery.service';
import { RedirectService } from 'src/app/services/redirect.service';
import { UserService } from 'src/app/services/user.service';

@Injectable({
  providedIn: 'root',
})
export class GalleryUnsubscribeGuard {
  constructor(
    private galleryService: GalleryService,
    private redirectService: RedirectService,
    private userService: UserService,
    @Inject(PLATFORM_ID) private platformId: string
  ) {}

  async canActivate(next: ActivatedRouteSnapshot): Promise<UrlTree | boolean> {
    if (isPlatformServer(this.platformId)) return true;
    await this.userService.getUser();
    const path = getFullPath(next);

    try {
      // Using id instead of the usual getFromRoute because this link is only ever used in emails where we specify the id.
      // Its important that this stays that way because we can't unsubscribe with the path, and if the gallery has a password
      // we cant get the id from the path.
      await this.galleryService.getGallery(next.params.galleryId, { ignore401Errors: true });
      return true;
    } catch (error) {
      if (!(error instanceof HttpErrorResponse)) throw error;
      if (error.status === 404) {
        return this.redirectService.redirectTo(['not-found', ...path]);
      }
      // Even if there is a password that we don't know we are still going to let them unsubscribe
      return true;
    }
  }
}
